import { analytics } from './firebase';
import { logEvent } from 'firebase/analytics';

/**
 * Log a custom event to Firebase Analytics
 * @param {string} eventName - The name of the event
 * @param {object} eventParams - Optional parameters for the event
 */
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    try {
      logEvent(analytics, eventName, eventParams);
    } catch (error) {
      console.error('Failed to log analytics event:', error);
    }
  }
};

/**
 * Log page view
 * @param {string} pageName - The name of the page
 * @param {string} pagePath - The path of the page
 */
export const logPageView = (pageName, pagePath) => {
  logAnalyticsEvent('page_view', {
    page_name: pageName,
    page_path: pagePath,
  });
};

/**
 * Log user sign up
 * @param {string} method - Sign up method (email, google, etc.)
 */
export const logSignUp = (method) => {
  logAnalyticsEvent('sign_up', {
    method,
  });
};

/**
 * Log user login
 * @param {string} method - Login method (email, google, etc.)
 */
export const logLogin = (method) => {
  logAnalyticsEvent('login', {
    method,
  });
};

/**
 * Log gacha spin event
 * @param {string} machineId - Machine ID
 * @param {number} tokenCost - Token cost for the spin
 */
export const logGachaSpin = (machineId, tokenCost) => {
  logAnalyticsEvent('gacha_spin', {
    machine_id: machineId,
    token_cost: tokenCost,
  });
};

/**
 * Log token purchase
 * @param {string} bundleId - Bundle ID
 * @param {number} tokens - Number of tokens purchased
 * @param {number} value - Purchase value in cents
 */
export const logTokenPurchase = (bundleId, tokens, value) => {
  logAnalyticsEvent('purchase', {
    bundle_id: bundleId,
    tokens,
    value,
    currency: 'USD',
  });
};

/**
 * Log locker expansion
 */
export const logLockerExpansion = () => {
  logAnalyticsEvent('locker_expansion');
};

/**
 * Log locker shipment
 * @param {number} itemCount - Number of items shipped
 * @param {number} shippingFee - Shipping fee in cents (0 for free shipping)
 */
export const logLockerShipment = (itemCount, shippingFee) => {
  logAnalyticsEvent('locker_shipment', {
    item_count: itemCount,
    shipping_fee: shippingFee,
    free_shipping: shippingFee === 0,
  });
};

/**
 * PonDisplay (Locker Showcase) analytics
 */
export const logLockerShowcaseOpened = (userId) => {
  logAnalyticsEvent('locker_showcase_opened', userId ? { user_id: userId } : {});
};

export const logLockerShowcaseItemSelected = (userId, selectedCount, itemKeys = []) => {
  logAnalyticsEvent('locker_showcase_item_selected', {
    ...(userId ? { user_id: userId } : {}),
    selected_count: selectedCount,
    item_ids: itemKeys,
  });
};

export const logLockerShowcaseExportClicked = (userId, format) => {
  logAnalyticsEvent('locker_showcase_export_clicked', {
    ...(userId ? { user_id: userId } : {}),
    format,
  });
};

export const logLockerShowcaseExportSuccess = (userId, format, fileSize) => {
  logAnalyticsEvent('locker_showcase_export_success', {
    ...(userId ? { user_id: userId } : {}),
    format,
    ...(typeof fileSize === 'number' ? { file_size: fileSize } : {}),
  });
};

export const logLockerShowcaseExit = (userId, timeSpentSeconds, selectedCount) => {
  logAnalyticsEvent('locker_showcase_exit', {
    ...(userId ? { user_id: userId } : {}),
    time_spent: timeSpentSeconds,
    selected_count: selectedCount,
  });
};


